import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=64f4b520&"
import script from "./QRcode.vue?vue&type=script&lang=js&"
export * from "./QRcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports